const Tickets = {
  ticketsPath: () => `/api/tickets`,
  ticketPath: (id: string) => `/api/tickets/${id}`,
  boardingPdfPath: (partnerBookingId: string) => `/api/boarding_pdf/${partnerBookingId}`,
};

export default Tickets;
